import { parseHostname } from '@ta-interaktiv/parse-hostname';

/**
 * This component will append a new `link` element to the `head` with the
 * URL of a new stylesheet that contains the publication-specific styles and
 * fonts.
 *
 * @example <caption>For use in React</caption>
 * import {ThemeSwitch} from '@ta-interaktiv/react-theme-switch'
 *
 * function Component (props) {
 *   // The following component renders the page in the style of 'Das Magazin'
 *   return (
 *     <div>
 *       <ThemeSwitch mediaName='dasmagazin' />
 *     </div>
 *   )
 * }
 *
 *
 * @example <caption>As part of the constructor</caption>
 * import {ThemeSwitch as themeSwitch} from '@ta-interaktiv/react-theme-switch'
 *
 * class Component extends React.Component {
 *   constructor(props) {
 *     super(props)
 *
 *     themeSwitch({mediaName: 'dasmagazin'})
 *   }
 *
 *   render() {
 *     return <div>Your Component</div>
 *   }
 * }
 *
 *
 * @param props
 * @param {string} [props.mediaName=window.location] The domain name of the
 * publication to use for the style sheet. Uses the current domain name as
 * the default. In case there is no stylesheet found under the URL, it will
 * fall back to the tagesanzeiger styles.
 * @returns {null}
 * @constructor
 */
export function ThemeSwitch(_ref) {
  var mediaName = _ref.mediaName;
  // in case no media name has been provided, we use a fallback
  // generally, this should always be provided by the masthead component
  mediaName = mediaName || parseHostname().publicationName; // construct resource URL
  // Always use the current publication domain to get the file

  var url = "https://interaktiv.".concat(parseHostname().publicationDomain, "/static/themes/").concat(mediaName, ".css"); // load the CSS stylesheet

  var cssLink = window.document.createElement('link');
  cssLink.type = 'text/css';
  cssLink.rel = 'stylesheet';
  cssLink.href = url;
  cssLink.media = 'screen,print';
  window.document.head.appendChild(cssLink);
  return null;
}
export default ThemeSwitch;